module.exports = __webpack_public_path__ + "img/table.b2e294bd.png";